export default {
    // récuperer toutes les agences dans la base de données 
    get_all_agencies(){
        return axios.get('/agences/list', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_agencies_by_entity(serverParams){
        return axios.post('/agences/entite/' + serverParams.entite_id + '?page=' + serverParams.page, serverParams,{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_agenciesOwn(serverParams){
        return axios.post('/agence/list?page=' + serverParams.page,serverParams,{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    agence_active(serverParams){
        return axios.get('/agence/getactive',{
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les agences dans la base de données 
    post_agency(agence){
        return axios.post('/agences',agence, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_agency(id,agence){
        return axios.put('/agences/'+id,agence, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_agency(id){
        return axios.get('/agences/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_agences(id){
        return axios.get('/desactive/agence/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    active_agences(id){
        return axios.get('/active/agence/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}